/**
 * Human label appended to a native video card's title to surface its pipeline
 * state. Kept as a pure function (separate from the component) so the wording
 * and the byte-vs-percent decision are unit-testable.
 *
 * Progress is shown in BYTES, not a rounded percent: on a multi-GB upload each
 * 8 MB chunk is <0.5% of the file, so `Math.round(pct)` would read "0%" for
 * minutes and look stuck. "queued" is the create-flow deferred state (file
 * picked, upload waits for the ritual to exist) -- distinct from "uploading".
 */

import { formatBytes } from "./videoGates"

interface NativeVideoLike {
  status: string
  uploadedBytes: number
  totalBytes: number
}

export const nativeVideoStatusSuffix = (v: NativeVideoLike): string => {
  switch (v.status) {
    case "queued":
      return " (Queued)"
    case "uploading":
      return v.totalBytes > 0
        ? ` (Uploading ${formatBytes(v.uploadedBytes)} / ${formatBytes(v.totalBytes)})`
        : " (Uploading…)"
    case "processing":
    case "pending":
      return " (Processing…)"
    case "failed":
    case "error":
      return " (Failed)"
    default:
      return "" // ready
  }
}
